import React, { useState } from "react";
import { detectInAppBrowser, escapeToBrowser } from "@/lib/inAppBrowser";
import { ExternalLink, X } from "lucide-react";

const STORAGE_KEY = "iarisk_iab_banner_dismissed";

export default function InAppBrowserBanner() {
  const info = detectInAppBrowser();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (!info || dismissed) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch { /* noop */ }
    setDismissed(true);
  };

  return (
    <div
      data-testid="in-app-browser-banner"
      className="fixed top-0 inset-x-0 z-[80] bg-amber-500/95 text-black px-4 py-3 flex items-center gap-3 shadow-md"
      style={{ paddingTop: "calc(env(safe-area-inset-top) + 12px)" }}
    >
      <div className="flex-1 text-[13px] leading-tight">
        <strong>Estás dentro de {info.label}.</strong>{" "}
        Para evitar fallos (sesión, notificaciones, descargas), abre la app en Chrome o Safari.
      </div>
      <button
        onClick={() => escapeToBrowser()}
        data-testid="open-in-browser-btn"
        className="bg-black text-amber-400 text-xs font-bold px-3 py-2 rounded-sm flex items-center gap-1.5 whitespace-nowrap"
      >
        <ExternalLink size={13} strokeWidth={2.5} />
        Abrir
      </button>
      <button
        onClick={dismiss}
        data-testid="dismiss-iab-banner-btn"
        aria-label="Cerrar"
        className="text-black/70 hover:text-black"
      >
        <X size={18} strokeWidth={2.5} />
      </button>
    </div>
  );
}
